<template>
  <div class="subscribedcodes-page">

    <el-table
      :data="subscribedcode"
      style="width: 100%">
      <el-table-column prop="codeid" type="index" column-key='codeid' width="60">
        <template slot-scope="scope">
          <button type="button" class="subcode-button-arrow-right" @click="jumpToSingleCodeAnalysis(scope.row.codeid)"><i class="el-icon-arrow-right"></i></button>
          <!-- <i class="el-icon-arrow-right"></i> -->
          <!-- <el-button type="danger" icon="el-icon-arrow-right" circle></el-button> -->
        </template>        
      </el-table-column>
      <el-table-column prop="codeid" :label="$t('subscribedcodes.t01')" width="100"></el-table-column>
      <el-table-column prop="codedigit" :label="$t('subscribedcodes.t02')" width="150"></el-table-column>
      <el-table-column prop="codetitle" :label="$t('subscribedcodes.t03')"></el-table-column>
      <el-table-column prop="codesection" :label="$t('subscribedcodes.t04')"></el-table-column>
      <el-table-column width="100">
        <template slot-scope="scope">  
          <el-button
            class="deletecodebtn"
            type="text"
            size="medium"
            @click.native.prevent="deleteRow(scope.$index, subscribedcode, scope.row)">
            <i class="el-icon-delete"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-tooltip
      :disabled="tooltipdisabled"
      class="item" 
      effect="light"
      placement="right">
      <div slot="content">{{ $t('subscribedcodes.t05') }}<br>{{ $t('subscribedcodes.t06') }}<br>{{ $t('subscribedcodes.t07') }}</div>
      <el-button class="addcodebtn" type="text" @click="addCode()"><i class="el-icon-circle-plus-outline"></i></el-button>
    </el-tooltip>

  </div>
</template>

<script>
export default {

  data(){
    return{
      tooltipdisabled: true,
      subscribedcode: [],
      totalcodes: 0,
    }
  },

  mounted(){
    this.getCodelists()
  },

  methods: {

    /**
     * 前端删除代码
     */
    deleteRow: function(index, rows, data) {
      this.deleteCode(data.codeid)
      rows.splice(index, 1)
      this.confirmdel = false
    },

    /**
     * 取消删除
     */
    canceldel: function(){
      this.confirmdel = false
    },

    /**
     * 添加Code
     */
    addCode: function(){
      let that = this
      if(that.totalcodes === 5){
        if( that.getLocalStorage('useraccount') === 'trade.intelligence.test@outlook.com' ){
          that.$router.push('/CodeList')
        }else{
          return
        }
      }else{
        that.$router.push('/CodeList')
      }
    },

    /**
     * 后端删除代码
     */
    deleteCode: function(codeid){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/cart/delete?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify({
          code: codeid
        }),
        contentType: "application/json",
        success: function(data) {
          console.log(data)
          that.getCodelists()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 获取购物车
     */
    getCodelists: function(){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/cart/info?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      that.subscribedcode = []
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log('getCodelists', rex)
          let codelists = rex.data.cartList.code_list
          that.$store.state.codelistobj = codelists
          that.tooltipdisabled = true
          that.totalcodes = codelists.length
          if(that.totalcodes === 5 && that.getLocalStorage('useraccount') !== 'trade.intelligence.test@outlook.com'){
            that.tooltipdisabled = false
          }
          for(let i=0; i<codelists.length; i++){
            let dataobj = {}
            dataobj.codeid = codelists[i].code
            dataobj.codedigit = codelists[i].code.length + ' digital'
            dataobj.codetitle = codelists[i].title
            dataobj.codesection = codelists[i].section
            that.subscribedcode.push(dataobj)
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 跳转至 SingleCodeAnalysis
     */
    jumpToSingleCodeAnalysis: function(cid){
      let that = this
      console.log('setLocalStorage')
      that.setLocalStorage('currentcodeid', cid)
      that.$router.push('/SingleCodeAnalysis')
    },

  }
}
</script>